import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CotacaoAbertoListComponent } from './cotacao-aberto-list/cotacao-aberto-list.component';
import { CotacaoAbertoEditComponent } from './cotacao-aberto-edit/cotacao-aberto-edit.component';
import { CondicaoPagamentoResolve } from './cotacao-aberto-edit/condicao-pagamento.resolver';


const routes: Routes = [
    {path: '', redirectTo: 'em-aberto', pathMatch: 'full'},
    { path: 'em-aberto', component: CotacaoAbertoListComponent },
    {
        path: 'em-aberto/edit/:idCotacao', component: CotacaoAbertoEditComponent,resolve:{
            condicaoPagamento: CondicaoPagamentoResolve
        }
    },
    {
        path: 'em-aberto/view/:idCotacao', component: CotacaoAbertoEditComponent,resolve:{
            condicaoPagamento: CondicaoPagamentoResolve
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CotacaoRoutingModule { }
